module.exports = __webpack_public_path__ + "img/germany-lung-cancer-male.9435ff64.png";